import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

import clsx from 'clsx';

const ErrorMessage = dynamic(
  () => import('./ErrorMessage').then((mod) => mod.ErrorMessage),
  { ssr: false }
);
const Label = dynamic(() => import('./Label').then((mod) => mod.Label), {
  ssr: false,
});

type FormItem = {
  name: string;
  label?: string | ReactNode;
  labelClassName?: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
  className?: string;
  tooltip?: React.ReactNode;
  description?: string;
  dataTestId: string;
};

export function FormItem(props: FormItem) {
  const {
    name,
    required,
    error,
    label,
    labelClassName,
    children,
    className,
    tooltip,
    description,
    dataTestId,
  } = props;

  return (
    <div
      className={clsx(className, 'flex flex-col w-full')}
      data-testid={dataTestId}
    >
      {label && (
        <Label
          htmlFor={name}
          required={required}
          hasError={!!error}
          tooltip={tooltip}
          className={clsx(labelClassName, 'mb-[2px]')}
        >
          {label}
        </Label>
      )}
      {children}
      {description && (
        <p className="mt-1 text-xs text-grey-25">{description}</p>
      )}
      {error && (
        <ErrorMessage
          text={error}
          className="mt-[2px]"
          data-testid={`${dataTestId}-error`}
        />
      )}
    </div>
  );
}
